module.exports = __webpack_public_path__ + "img/39_44.fed628ac.png";